import { connect } from "react-redux";
import { ProductActionsContainer as SourceProductActionsContainer } from 'SourceComponent/ProductActions/ProductActions.container';
import { showPopup } from 'Store/Popup/Popup.action';
import { DEFAULT_MAX_PRODUCTS } from './ProductActions.config';


export const mapStateToProps = (state) => ({
    groupedProductQuantity: state.ProductReducer.groupedProductQuantity,
    deepArEnabled: true
});
export const mapDispatchToProps = (dispatch) => ({
    showPopup: (payload) => dispatch(showPopup('DeepAr_Overlay_id', payload)),
});

export class ProductActionsContainer extends SourceProductActionsContainer {

    state = { selectedSwatchCode : null, DeepArComponent: null};
    containerProps = () => ({
        minQuantity: SourceProductActionsContainer.getMinQuantity(this.props),
        maxQuantity: this.constructor.getMaxQuantity(this.props),
        groupedProductQuantity: this._getGroupedProductQuantity(),
        productPrice: this.getProductPrice(),
        cartRuleSpecialPrice: this.getCartRuleSpecialPrice(),
        productName: this.getProductName(),
        offerCount: this.getOfferCount(),
        offerType: this.getOfferType(),
        stockMeta: this.getStockMeta(),
        metaLink: this.getMetaLink(),
        showDeepArPopup: this._showDeepArPopup.bind(this),
        updateVariantInDeepAr: this._updateVariantInDeepAr.bind(this),
        selectedSwatch: this.state.selectedSwatchCode,
        deepArEnabled: this.props.deepArEnabled,
        DeepArComponent: this.state.DeepArComponent
    });

    _updateVariantInDeepAr(attribute_code, attribute_value) {
        console.log('updated Swatch in DeepAR', attribute_code, attribute_value);
        this.setState({selectedSwatchCode: attribute_value});
    }

    static getMaxQuantity(props) {
        const {
            product: {
                stock_item: {
                    max_sale_qty
                } = {},
                variants
            } = {},
            configurableVariantIndex
        } = props;

        if (!max_sale_qty) {
            return DEFAULT_MAX_PRODUCTS;
        }

        if (configurableVariantIndex === -1 || !Object.keys(variants).length) {
            return max_sale_qty;
        }

        const {
            stock_item: {
                max_sale_qty: maxVariantQty
            } = {}
        } = variants[configurableVariantIndex] || {};

        return maxVariantQty || max_sale_qty;
    }
    _showDeepArPopup() {
        const {
            showPopup
        } = this.props;

        import("Component/DeepAr")
            .then((module) => {
                this.setState({DeepArComponent: module?.default});
                this.setState({closedDeepAr: false});
                showPopup({ title: __('Try Products in AR!') });
            })
            .catch((error) => {
                Sentry.captureException(error);
            });
    }

    getIsConfigurableAttributeAvailable({ attribute_code, attribute_value }) {
        const { parameters, product: { variants } } = this.props;

        const isAttributeSelected = Object.hasOwnProperty.call(parameters, attribute_code);

        // If value matches current attribute_value, option should be enabled
        if (isAttributeSelected && parameters[attribute_code] === attribute_value) {
            return true;
        }

        const parameterPairs = Object.entries(parameters);

        const selectedAttributes = isAttributeSelected
            // Need to exclude itself, otherwise different attribute_values of the same attribute_code will always be disabled
            ? parameterPairs.filter(([key]) => key !== attribute_code)
            : parameterPairs;

        return variants
            .some(({ attributes }) => {
                const { attribute_value: foundValue } = attributes[attribute_code] || {};

                return (
                    // Variant must have currently checked attribute_code and attribute_value
                    foundValue === attribute_value
                    // Variant must have all currently selected attributes
                    && selectedAttributes.every(([key, value]) => attributes[key].attribute_value === value)
                );
            });
    }

    getCartRuleSpecialPrice() {
        const {
            product,
            product: { variants = [] },
            configurableVariantIndex
        } = this.props;

        const {
            cart_rule_special_price: cartRuleSpecialPrice
        } = variants[configurableVariantIndex] || product;

        return cartRuleSpecialPrice;
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ProductActionsContainer);
